import styled from 'styled-components'
import type { ReactNode } from 'react'
import { Title } from 'components/Title'
import bgImage from 'assets/header-img.png'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '../Skeleton'

export interface DashboardHeaderProps {
  readonly name: string | undefined
  readonly isloading?: boolean
  readonly isMobile?: boolean
  readonly actions?: ReactNode
}

export const DashHead = styled.div<{ isMobile: boolean; hasActions: boolean }>`
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  padding: ${props => (props.isMobile ? '0px 30px' : '24px 30px')};
  height: ${props => (props.isMobile ? '82px' : props.hasActions ? '180px' : '138px')};
  background: #4263eb;
  /* Arc gets the brand gradient via --arc-header-bg-image (app.css); legacy
     schools keep the original PNG through the var() fallback */
  background-image: var(--arc-header-bg-image, url('${bgImage}'));
  background-position: center;
  background-size: cover;
`
export const StyledTitle = styled(Title)`
  color: white;
  font-weight: 700;
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  margin-left: 100px;
  height: 100%;
  gap: 12px;
  padding-bottom: 16px;
`

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  name,
  isloading = false,
  isMobile = false,
  actions,
}) => {
  const { t } = useTranslation()
  const hasActions = Boolean(actions)

  return (
    <Skeleton
      visible={isloading}
      color='indigo.7'
      height={isMobile ? 82 : hasActions ? 180 : 138}
      width='100%'
      style={{ position: 'absolute', top: 0, left: 0 }}
    >
      <DashHead isMobile={isMobile} hasActions={hasActions}>
        {!isMobile && (
          <Container>
            {name === undefined ? (
              <Skeleton visible h={60} w={400} mt={32} />
            ) : (
              <>
                <StyledTitle order={1}>
                  {t('students_hello')} {name}
                </StyledTitle>
                {actions}
              </>
            )}
          </Container>
        )}
      </DashHead>
    </Skeleton>
  )
}
